import TournamentAPI from '../api/tournament';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    category: false,
    error: null,
    requestSend: false,
    requestSuccessful: false,
    requestFail: false,
    isModalFormShow: true,
    tournaments: [],
    tournamentOne: {},
    drawingDrafts: {}, // Store draft state per category: { categoryId: { sortableSheme, timestamp, unsavedChanges } }
    drawingHistory: {} // Store change history per category: { categoryId: [{ version, timestamp, description, drawdata, action }] }
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    requestSend(state) {
      return state.requestSend;
    },
    requestSuccessful(state) {
      return state.requestSuccessful;
    },
    hasError(state) {
      return state.error !== null;
    },
    error(state) {
      return state.error;
    },
    hasTournaments(state) {
      return state.tournaments.data && Object.keys(state.tournaments.data.list).length > 0 ? true : false;
    },
    isModalFormShow(state) {
      return state.isModalFormShow;
    },
    tournaments(state) {
      return state.tournaments;
    },
    tournamentOne(state) {
      return state.tournamentOne;
    },
    categoryOne(state) {
      return state.category;
    },
    getDrawingDraft: (state) => (categoryId) => {
      return state.drawingDrafts[categoryId] || null;
    },
    hasDrawingDraft: (state) => (categoryId) => {
      return !!state.drawingDrafts[categoryId];
    },
    getDrawingHistory: (state) => (categoryId) => {
      return state.drawingHistory[categoryId] || [];
    },
    hasDrawingHistory: (state) => (categoryId) => {
      return !!(state.drawingHistory[categoryId] && state.drawingHistory[categoryId].length > 0);
    },
  },
  mutations: {
    ['BRACKET_UPDATE_SUCCESS'](state) {
      state.isLoading = true;
      state.requestSend = true;
      // state.error = null;
    },
    ['EVENT_STARTED_SUCCESS'](state) {
      // state.isLoading = true;
      state.requestSend = true;
      // state.error = null;
    },

    ['BRACKET_UPDATE_ERROR'](state) {
      state.isLoading = true;
      state.requestSend = true;
      // state.error = null;
    },


    ['CREATING_SPORTSMAN'](state) {
      state.isLoading = true;
      state.requestSend = true;
      state.error = null;
    },

    ['SET_CATEGORY_DAYS'](state) {
      state.isLoading = true;
      state.requestSend = true;
      state.error = null;
    },
    ['SET_CATEGORY_DAYS_SUCCESS'](state) {
      state.isLoading = false;
      state.requestSend = true;
      state.error = null;
    },
    ['SET_CATEGORY_DAYS_ERROR'](state) {
      state.isLoading = false;
      state.requestSend = true;
      state.error = null;
    },
    ['CREATING_SPORTSMAN_SUCCESS'](state, post) {
      state.isLoading = false;
      state.requestSuccessful = true;
      state.isModalFormShow = false;
      state.requestSend = false;
      state.requestFail = false;
      state.error = null;
      // state.tournaments.unshift(post);
      // state.tournamentOne = post;
    },
    ['CREATING_SPORTSMAN_ERROR'](state, error) {
      state.isLoading = false;
      state.requestSuccessful = false;
      state.requestSend = false;
      state.requestFail = true;
      state.error = error;
      // state.tournaments = [];
    },


 ['CREATING_CATEGORY'](state) {
      state.isLoading = true;
      state.requestSend = true;
      state.error = null;
    },
    ['CREATING_CATEGORY_SUCCESS'](state, post) {
      state.isLoading = false;
      state.requestSuccessful = true;
      state.isModalFormShow = false;
      state.requestSend = false;
      state.requestFail = false;
      state.error = null;
      // state.tournaments.unshift(post);
      // state.tournamentOne = post;
    },
    ['CREATING_CATEGORY_ERROR'](state, error) {
      state.isLoading = false;
      state.requestSuccessful = false;
      state.requestSend = false;
      state.requestFail = true;
      state.error = error;
      // state.tournaments = [];
    },


    ['CREATING_TOURNAMENT'](state) {
      state.isLoading = true;
      state.requestSend = true;
      state.error = null;
    },
    ['CREATING_TOURNAMENT_SUCCESS'](state, post) {
      state.isLoading = false;
      state.requestSuccessful = true;
      state.isModalFormShow = false;
      state.requestSend = false;
      state.requestFail = false;
      state.error = null;
      // Only update tournamentOne, don't try to add to tournaments list
      // because state.tournaments might be an object {data: {...}} from API, not an array
      state.tournamentOne = post;
    },
    ['CREATING_TOURNAMENT_ERROR'](state, error) {
      state.isLoading = false;
      state.requestSuccessful = false;
      state.requestSend = false;
      state.requestFail = true;
      state.error = error;
      state.tournaments = [];
    },

    ['UPDATING_TOURNAMENT'](state) {
      state.isLoading = false;
      state.requestSend = true;
      state.error = null;
    },
    ['UPDATING_TOURNAMENT_SUCCESS'](state, post) {
      state.isLoading = false;
      state.requestSuccessful = true;
      state.isModalFormShow = false;
      state.requestSend = false;
      state.requestFail = false;
      state.error = null;
      state.tournamentOne = post;
    },
    ['UPDATING_TOURNAMENT_ERROR'](state, error) {
      state.isLoading = false;
      state.requestSuccessful = false;
      state.requestSend = false;
      state.requestFail = true;
      state.error = error;
      state.tournaments = [];
    },

    ['FETCHING_TOURNAMENTS'](state) {
      state.isLoading = true;
      state.error = null;
      state.tournaments = [];
    },
    ['FETCHING_TOURNAMENTS_SUCCESS'](state, tournaments) {
      state.isLoading = false;
      state.error = null;
      state.tournaments = tournaments;
    },
    ['FETCHING_TOURNAMENTS_ERROR'](state, error) {
      state.isLoading = false;
      state.error = error;
      state.tournaments = [];
    },



    ['FETCHING_CATEGORY_ONE'](state) {
      state.isLoading = true;
      state.error = null;
      state.category = [];
    },
    ['FETCHING_CATEGORY_ONE_SUCCESS'](state, category) {
      state.isLoading = false;
      state.error = null;
      state.category = category;
    },
    ['FETCHING_CATEGORY_ONE_ERROR'](state, error) {
      state.isLoading = false;
      state.error = error;
      state.category = [];
    },


    ['FETCHING_TOURNAMENT_ONE'](state) {
      state.isLoading = true;
      state.error = null;
      state.tournament = {};
    },
    ['FETCHING_TOURNAMENT_ONE_SUCCESS'](state, tournamentOne) {
      state.isLoading = false;
      state.error = null;
      console.log(state.tournamentOne);
      state.tournamentOne = tournamentOne;
    },
    ['FETCHING_TOURNAMENT_ONE_ERROR'](state, error) {
      state.isLoading = false;
      state.error = error;
      state.tournament = {};
    },

    ['SHOW_MODAL_FORM_TOURNAMENT'](state, error) {
      state.isModalFormShow = true;
    },
    ['HIDE_MODAL_FORM_TOURNAMENT'](state, error) {
      state.isModalFormShow = false;
    },
    ['DELETING_TOURNAMENT'](state, error) {
      // state.isModalFormShow = true;
    },
    ['DELETING_TOURNAMENT_SUCCESS'](state, error) {
      // state.isModalFormShow = false;
    },
    ['DELETING_TOURNAMENT_ERROR'](state, error) {
      // state.isModalFormShow = false;
    },

    // Drawing Draft mutations
    ['SAVE_DRAWING_DRAFT'](state, { categoryId, draftState }) {
      state.drawingDrafts = {
        ...state.drawingDrafts,
        [categoryId]: {
          ...draftState,
          timestamp: new Date().toISOString()
        }
      };
      // Persist to localStorage
      try {
        localStorage.setItem('drawingDrafts', JSON.stringify(state.drawingDrafts));
      } catch (e) {
        console.error('Failed to save draft to localStorage:', e);
      }
    },
    ['CLEAR_DRAWING_DRAFT'](state, categoryId) {
      const { [categoryId]: removed, ...rest } = state.drawingDrafts;
      state.drawingDrafts = rest;
      // Update localStorage
      try {
        localStorage.setItem('drawingDrafts', JSON.stringify(state.drawingDrafts));
      } catch (e) {
        console.error('Failed to update localStorage:', e);
      }
    },
    ['LOAD_DRAWING_DRAFTS'](state) {
      try {
        const drafts = localStorage.getItem('drawingDrafts');
        if (drafts) {
          state.drawingDrafts = JSON.parse(drafts);
        }
      } catch (e) {
        console.error('Failed to load drafts from localStorage:', e);
        state.drawingDrafts = {};
      }
    },

    // Drawing History mutations
    ['ADD_DRAWING_HISTORY'](state, { categoryId, historyEntry }) {
      if (!state.drawingHistory[categoryId]) {
        state.drawingHistory[categoryId] = [];
      }

      // Add version number
      const currentHistory = state.drawingHistory[categoryId];
      const version = currentHistory.length + 1;

      const entry = {
        ...historyEntry,
        version,
        timestamp: new Date().toISOString()
      };

      // Keep only last 20 versions to avoid memory issues
      if (currentHistory.length >= 20) {
        currentHistory.shift();
      }

      currentHistory.push(entry);
      state.drawingHistory = { ...state.drawingHistory };

      // Persist to localStorage
      try {
        localStorage.setItem('drawingHistory', JSON.stringify(state.drawingHistory));
      } catch (e) {
        console.error('Failed to save history to localStorage:', e);
      }
    },
    ['CLEAR_DRAWING_HISTORY'](state, categoryId) {
      const { [categoryId]: removed, ...rest } = state.drawingHistory;
      state.drawingHistory = rest;
      try {
        localStorage.setItem('drawingHistory', JSON.stringify(state.drawingHistory));
      } catch (e) {
        console.error('Failed to update localStorage:', e);
      }
    },
    ['LOAD_DRAWING_HISTORY'](state) {
      try {
        const history = localStorage.getItem('drawingHistory');
        if (history) {
          state.drawingHistory = JSON.parse(history);
        }
      } catch (e) {
        console.error('Failed to load history from localStorage:', e);
        state.drawingHistory = {};
      }
    },
  },
  actions: {
    deleteTournament({commit}, params) {
      commit('DELETING_TOURNAMENT');
      return TournamentAPI.delete(params)
        .then(res => commit('DELETING_TOURNAMENT_SUCCESS', res.data))
        .catch(err => commit('DELETING_TOURNAMENT_ERROR', err));
    },

    deleteTournamentAllSportsmans({commit}, params) {
      commit('DELETING_TOURNAMENT');
      return TournamentAPI.deleteTournamentAllSportsmans(params)
        .then(res => commit('DELETING_TOURNAMENT_SUCCESS', res.data))
        .catch(err => commit('DELETING_TOURNAMENT_ERROR', err));
    },
    deleteOneSportsman({commit}, params) {
      commit('DELETING_TOURNAMENT');
      return TournamentAPI.deleteOneSportsman(params)
        .then(res => commit('DELETING_TOURNAMENT_SUCCESS', res.data))
        .catch(err => commit('DELETING_TOURNAMENT_ERROR', err));
    },
    deleteOneCategory({commit}, params) {
      commit('DELETING_TOURNAMENT');
      return TournamentAPI.deleteOneCategory(params)
        .then(res => commit('DELETING_TOURNAMENT_SUCCESS', res.data))
        .catch(err => commit('DELETING_TOURNAMENT_ERROR', err));
    },
    createTournament({commit}, params) {
      console.log('🏪 [STORE] createTournament called with params:', params);
      commit('CREATING_TOURNAMENT');
      return TournamentAPI.create(params)
        .then(res => {
          console.log('🏪 [STORE] API response received:', res);
          console.log('🏪 [STORE] res.data:', res.data);
          commit('CREATING_TOURNAMENT_SUCCESS', res.data);
          console.log('🏪 [STORE] Returning res.data to component:', res.data);
          return res.data; // Return response data
        })
        .catch(err => {
          console.error('🏪 [STORE] API error:', err);
          commit('CREATING_TOURNAMENT_ERROR', err);
          throw err; // Re-throw error
        });
    },
    addSportsman({commit}, params) {
      commit('CREATING_SPORTSMAN');
      return TournamentAPI.createSportsman(params)
        .then(res => commit('CREATING_SPORTSMAN_SUCCESS', res.data))
        .catch(err => commit('CREATING_SPORTSMAN_ERROR', err));
    },
    addCategory({commit}, params) {
      commit('CREATING_CATEGORY');
      return TournamentAPI.createCategory(params)
        .then(res => commit('CREATING_CATEGORY_SUCCESS', res.data))
        .catch(err => commit('CREATING_CATEGORY_ERROR', err));
    },
    setCategoryDays({commit}, params) {
      commit('SET_CATEGORY_DAYS');
      return TournamentAPI.setCategoryDays(params)
        .then(res => commit('SET_CATEGORY_DAYS_SUCCESS', res.data))
        .catch(err => commit('SET_CATEGORY_DAYS_ERROR', err));
    },
    updateTournament({commit}, params) {
      commit('UPDATING_TOURNAMENT');
      return TournamentAPI.update(params)
        .then(res => {
          commit('UPDATING_TOURNAMENT_SUCCESS', res.data);
          return res.data; // Return response data
        })
        .catch(err => {
          commit('UPDATING_TOURNAMENT_ERROR', err);
          throw err; // Re-throw error
        });
    },
    showModalForm({commit}, val) {
      if (val === true) {
        commit('SHOW_MODAL_FORM_TOURNAMENT');
      } else {
        commit('HIDE_MODAL_FORM_TOURNAMENT');
      }

      return true;
    },
    fetchTournaments({commit}) {
      commit('FETCHING_TOURNAMENTS');
      return TournamentAPI.getAll()
        .then(res => commit('FETCHING_TOURNAMENTS_SUCCESS', res.data))
        .catch(err => commit('FETCHING_TOURNAMENTS_ERROR', err));
    },

    fetchTournamentOne({commit}, params) {
      commit('FETCHING_TOURNAMENT_ONE');
      return TournamentAPI.getOne(params)
        .then(res => commit('FETCHING_TOURNAMENT_ONE_SUCCESS', res.data))
        .catch(err => commit('FETCHING_TOURNAMENT_ONE_ERROR', err));
    },

    fetchCategoryOne({commit}, params) {
      commit('FETCHING_CATEGORY_ONE');
      return TournamentAPI.getCategoryOne(params)
        .then(res => commit('FETCHING_CATEGORY_ONE_SUCCESS', res.data))
        .catch(err => commit('FETCHING_CATEGORY_ONE_ERROR', err));
    },

    fetchTournamentOneFull({commit}, params) {
      commit('FETCHING_TOURNAMENT_ONE');
      return TournamentAPI.getOneFull(params)
        .then(res => commit('FETCHING_TOURNAMENT_ONE_SUCCESS', res.data))
        .catch(err => commit('FETCHING_TOURNAMENT_ONE_ERROR', err));
    },

    syncTournamentSportsmans({commit}, params) {
      commit('FETCHING_TOURNAMENT_SYNC_ONE');
      return TournamentAPI.getDataSync(params)
        .then(res => commit('FETCHING_TOURNAMENT_SYNC_ONE_SUCCESS', res.data))
        .catch(err => commit('FETCHING_TOURNAMENT_SYNC_ONE_ERROR', err));
    },


    verifyOneSportsman({commit}, params) {
      commit('FETCHING_VERIFY_SPORTSMAN');
      return TournamentAPI.verifyOneSportsman(params)
        .then(res => commit('FETCHING_VERIFY_SPORTSMAN_SUCCESS', res.data))
        .catch(err => commit('FETCHING_VERIFY_SPORTSMAN_ERROR', err));
    },

    verifyAllSportsman({commit}, params) {
      commit('FETCHING_VERIFY_SPORTSMAN');
      return TournamentAPI.verifyAllSportsman(params)
        .then(res => commit('FETCHING_VERIFY_SPORTSMAN_SUCCESS', res.data))
        .catch(err => commit('FETCHING_VERIFY_SPORTSMAN_ERROR', err));
    },



    uploadFileCSV({commit}, formData) {
      commit('FETCHING_TOURNAMENT_ONE');
      return TournamentAPI.uploadFile(formData)
        .then(res => commit('FETCHING_TOURNAMENT_ONE_SUCCESS', res.data))
        .catch(err => commit('FETCHING_TOURNAMENT_ONE_ERROR', err));
    },


    sortableCategoryListSave({commit}, params) {
      commit('CREATING_SPORTSMAN');
      return TournamentAPI.sortableCategoryListSave(params)
        .then(res => commit('CREATING_SPORTSMAN_SUCCESS', res.data))
        .catch(err => commit('CREATING_SPORTSMAN_ERROR', err));
    },


    createCategoryListFirst({commit}, params) {
      commit('CREATING_SPORTSMAN');
      return TournamentAPI.createCategoryListFirst(params)
        .then(res => commit('CREATING_SPORTSMAN_SUCCESS', res.data))
        .catch(err => commit('CREATING_SPORTSMAN_ERROR', err));
    },



    saveBracket({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.saveBracket(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    updateBracketFight({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.updateBracketFight(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    autoSortableBracket({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.autoSortableBracket(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    autoSortableBracketAll({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.autoSortableBracketAll(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    clearBracket({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.clearBracket(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    removeFromBracketSportsman({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.removeFromBracketSportsman(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    setPositionListSp({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.setPositionListSp(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    sePointsListSp({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.sePointsListSp(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    deleteSportsmanFromCategory({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.deleteSportsmanFromCategory(params)
        .then(res => commit('BRACKET_UPDATE_SUCCESS', res.data))
        .catch(err => commit('BRACKET_UPDATE_ERROR', err));
    },

    startEpEvent({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.startEpEvent(params)
        .then(res => {
          commit('EVENT_STARTED_SUCCESS', res.data);
          return res.data;
        })
        .catch(err => commit('EVENT_STARTED_ERROR', err));
    },

    randomEpEvent({commit}, params) {
      // commit('CREATING_SPORTSMAN');
      return TournamentAPI.randomEpEvent(params)
        .then(res => {
          commit('EVENT_STARTED_SUCCESS', res.data);
          return res.data;
        })
        .catch(err => commit('EVENT_STARTED_ERROR', err));
    },

    // Drawing Draft actions
    saveDrawingDraft({commit}, { categoryId, draftState }) {
      commit('SAVE_DRAWING_DRAFT', { categoryId, draftState });
    },
    clearDrawingDraft({commit}, categoryId) {
      commit('CLEAR_DRAWING_DRAFT', categoryId);
    },
    loadDrawingDrafts({commit}) {
      commit('LOAD_DRAWING_DRAFTS');
    },

    // Drawing History actions
    addDrawingHistory({commit}, { categoryId, historyEntry }) {
      commit('ADD_DRAWING_HISTORY', { categoryId, historyEntry });
    },
    clearDrawingHistory({commit}, categoryId) {
      commit('CLEAR_DRAWING_HISTORY', categoryId);
    },
    loadDrawingHistory({commit}) {
      commit('LOAD_DRAWING_HISTORY');
    },

  },
}
